import React, { useState, useEffect } from 'react';
import './CatalogueMobileHero.css';

const CatalogueMobileHero = () => {
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 570);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 570);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const heroBgStyle = {
        backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0.84), rgba(255, 255, 255, 0)), url('/images/ResidentialBuilding.webp')`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
    };

    return (
        <div className="catalogue-hero-layout-wrapper">
            <div className="catalogue-mobile-hero" style={heroBgStyle}>
                <div className="catalogue-hero-top-overlay"></div>
                <div className="catalogue-hero-logo-container">
                </div>

                <div className="catalogue-hero-title-container">
                    <h1 className="catalogue-hero-main-title">A SMARTER<br />WAY TO SELL<br />REAL ESTATE</h1>
                </div>

                <div className="catalogue-hero-cta-container">
                    <button className="catalogue-hero-cta-button">
                        STOP SELLING.<br />START IMMERSING.
                    </button>
                </div>
            </div>
            <div className="catalogue-hero-video-overlay">
                <video
                    key={isSmallScreen ? 'small-vid' : 'large-vid'}
                    className="catalogue-hero-video"
                    autoPlay
                    loop
                    muted
                    playsInline
                >
                    <source
                        src={isSmallScreen ? "/videos/Demo1.mp4" : "/videos/cataloguvideo11.mp4"}
                        type="video/mp4"
                    />
                </video>
            </div>
        </div>
    );
};

export default CatalogueMobileHero;
